const FAILURE_STATUSES = new Set(['failed', 'no_credentials', 'missing_company_id']);

export const getStatusTagColor = (status: string): string | undefined => {
	const statusLower = status?.toLowerCase();

	switch (statusLower) {
		case 'sent':
			return 'processing';
		case 'delivered':
			return 'success';
		case 'bounced':
			return 'warning';
		case 'complaint':
			return 'warning';
		case 'failed':
		case 'missing_company_id':
		case 'no_credentials':
			return 'error';
		case 'processed':
			return 'processing';
		default:
			return 'default';
	}
};

export const isFailureStatus = (status?: string): boolean => FAILURE_STATUSES.has(status?.toLowerCase() ?? '');
